  <template>
  <va-card title="Problems">

    <!-- I don't think we need this functionality? -->
    <!-- <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="searchTerm"
          :placeholder="$t('tables.searchByName')"
          @input="search"
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div> -->

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table
      ref="datatable"
      :fields="fields"
      :data="filteredData"
      :allowSelect="false"
      no-pagination
      no-data-label="No problems"
      ext-link-field="__slot:extlink"
      v-if="!loading"
    >
      <template slot="datecreated" slot-scope="{rowData}">{{ formatAlertDate(rowData.date_created) }}</template>


      <!-- <template slot="actions" slot-scope="props">
        <va-popover :message="`${$t('tables.edit')} rule`" placement="left">
          <va-button flat small color="gray" icon="fa fa-pencil" @click="dialogEdit(props.rowData)"/>
        </va-popover>

        <va-popover :message="`${$t('tables.delete')} rule`" placement="left">
          <va-button flat small color="gray" icon="fa fa-trash" @click="dialogTrash(props.rowData)" />
        </va-popover>
      </template> -->
    </va-data-table>


  </va-card>
</template>

<script>
import { debounce } from 'lodash'
import hiqapi from '@/hiqapi/hiqapi'
import { formatDate, formatGwTime } from '@/common'
import { DateTime } from 'luxon'

export default {
  data() {
    return {
      loading: true,
      searchTerm: null,
      listData: [], // list of currentListType
    }
  },
  computed: {
    fields() {
      return [
        { name: '__slot:datecreated', sortField: 'date_created', title: 'Date', dataClass: 'text-center' },
        { name: 'description', sortField: 'description', title: 'Description', dataClass: 'text-center' },
        { name: 'site_name', sortField: 'site_name', title: 'Site', dataClass: 'text-center' },
        { name: 'gw_serial', sortField: 'gw_serial', title: 'Gateway', dataClass: 'text-center' },
        { name: 'inv_serial', sortField: 'inv_serial', title: 'Inverter', dataClass: 'text-center' },
        // { name: '__slot:actions', dataClass: 'text-right' },
      ]
    },
    filteredData() {
      let data = this.listData

      if (!this.searchTerm || this.searchTerm.length < 1) {
        return data
      }
      return data
      // return data.filter(item => {
      //   return item.alert_type.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1
      // })
    },
  },

  methods: {
    formatAlertDate(date) {
      let resp = DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
      return resp
    },


    setData(newval) {
      this.loading = false
      this.listData = newval.items

      console.log('PROBS SET DATA: ', newval)
    },
    search: debounce(function(searchTerm) {
      this.searchTerm = searchTerm
    }, 400),

    reload() {
      this.isLoading = true
      hiqapi.getcb('/alerts', this.setData)
    }
  },

  mounted() {
    this.reload()
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #BEBEBE;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.54, 0.18, 0.46, 0.82);
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
      -webkit-transform: rotate(0deg);
  }
  to {
      -webkit-transform: rotate(359deg);
  }
}
.extlink {
  color:#7596fb;
}
.extlink:hover {
  color: #0c30d3;
}

</style>
